import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { IAutomatedEmailCampaignListPayload } from 'wisestep-api';
import { WsColors, WsTypoColors, WsTypography } from 'wisestep-base';

import useGetJobCampaignAnalytics from '../../hooks/useGetJobCampaignAnalytics';
import {
  getCampaignAnalyticsColumns,
  getJobEmailCampaignAnalyticsPayload,
  IJobCampaignEmailAnalyticsTabs,
} from '../../util/JobCampaignEmailHelper';
import CampaignAnalyticsDrawer from '../campaignDrawer/CampaignAnalyticsDrawer';

export const EmailCampaignAnalytics = () => {
  const [params] = useSearchParams();
  const jobId = params.get('jobId') ?? '';
  const campaignCode = params.get('campaignCode') ?? '';
  const [analyticsParams] = useState<IAutomatedEmailCampaignListPayload>(
    getJobEmailCampaignAnalyticsPayload(jobId, campaignCode)
  );
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [tabName, setTabName] = useState<IJobCampaignEmailAnalyticsTabs>(
    IJobCampaignEmailAnalyticsTabs.SENT
  );

  const handleToggleOpenDrawer = () => setOpenDrawer((prev) => !prev);
  const { analytics } = useGetJobCampaignAnalytics(analyticsParams);

  const handleTabName = (tabName: IJobCampaignEmailAnalyticsTabs) => {
    handleToggleOpenDrawer();
    setTabName(tabName);
  };
  return (
    <>
      <WsTypography bold>Delivery Metrics</WsTypography>
      <Box sx={{ background: WsColors.White, height: 500, width: 500 }}>
        <DataGrid
          columns={[
            ...getCampaignAnalyticsColumns(),
            {
              field: 'count',
              headerName: 'Value',
              minWidth: 130,
              flex: 1,
              renderCell: (params) => (
                <WsTypography
                  onClick={() => {
                    handleTabName(params.row.delivery_status);
                  }}
                  color={WsTypoColors.PRIMARY750}
                  cursor="pointer"
                >
                  {params.value}
                </WsTypography>
              ),
            },
          ]}
          rows={
            analytics?.resultSet?.map((matric, index) => ({
              id: index,
              ...matric,
            })) ?? []
          }
          pageSize={10}
          rowsPerPageOptions={[10]}
        />
      </Box>
      {openDrawer && (
        <CampaignAnalyticsDrawer
          open={openDrawer}
          handleClose={handleToggleOpenDrawer}
          tabName={tabName}
        />
      )}
    </>
  );
};
